import { Routes } from '@angular/router';
import { HomeComponent } from './components/home-page/home/home.component';
import { AboutPageComponent } from './components/about-page/about-page.component';
import { ContactPageComponent } from './components/contact-page/contact-page.component';
import { serviceRoutes } from './components/service-page/services.routes';
import { FirstBlogComponent } from './components/blog-page/first-blog/first-blog.component';
import { SecondBlogComponent } from './components/blog-page/second-blog/second-blog.component';
import { ThirdBlogComponent } from './components/blog-page/third-blog/third-blog.component';
import { projectRoutes } from './components/portfolio-page/projects.routes';

export const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
  },
  {
    path: 'about',
    component: AboutPageComponent,
  },
  {
    path: 'services',
    children: serviceRoutes,
  },
  {
    path: 'blog-first',
    component: FirstBlogComponent,
  },
  {
    path: 'blog-second',
    component: SecondBlogComponent,
  },
  {
    path: 'blog-third',
    component: ThirdBlogComponent,
  },
  {
    path: 'contact',
    component: ContactPageComponent,
  },
  {
    path: 'portfolio',
    children: projectRoutes,
  },
  { path: '**', component: HomeComponent },
];
